import { Bounce, ToastContainer } from 'react-toastify';
import style from './toast-holder.module.scss';
import { TOAST_CONTAINER } from '../Toast';
import clsx from 'clsx';

const DEFAULT_TOAST_TIMEOUT = 6000;

type ToastHolderProps = {
  className?: string;
};

export const ToastHolder = ({ className }: ToastHolderProps) => {
  return (
    <ToastContainer
      position='top-right'
      autoClose={DEFAULT_TOAST_TIMEOUT}
      hideProgressBar={true}
      closeButton={false}
      newestOnTop={true}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss={true}
      draggable={false}
      pauseOnHover={true}
      transition={Bounce}
      className={clsx(style.toastHolder, className)}
      containerId={TOAST_CONTAINER}
    />
  );
};
